import { render, staticRenderFns } from "./baby.vue?vue&type=template&id=57afa95d&scoped=true"
import script from "./baby.vue?vue&type=script&lang=js"
export * from "./baby.vue?vue&type=script&lang=js"
import style0 from "./baby.vue?vue&type=style&index=0&id=57afa95d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57afa95d",
  null
  
)

export default component.exports